module.exports = __webpack_public_path__ + "static/img/open.bee31ba1.svg";